import React from 'react';
import { styled } from "../../../stitches.config";
import { ReactComponent as ProcesShadowText } from '../../../assets/img/natemat/tip/proces.svg?react';
import { h1, h3, h4, p } from '../../commonStyles/Fonts';
import { useWindowWidth } from '../../../helpers';

interface StepInstructionProps {
    children: JSX.Element,
    steps: {
        title: string,
        description: string
    }[]
}

const StepInstruction = ({ children, steps }: StepInstructionProps) => {

    const isDesktop = 992 < useWindowWidth();

    return (
        <Container>
            {children}
            <ProcesShadowText />
            <StepsWrapper>
                {
                    steps.map((item, index) =>
                        index < steps.length - 1 ?
                            <StepItem>
                                <NumberBox>
                                    <h3 className={isDesktop ? h3() : h4()}>{index + 1}</h3>
                                    <Dots></Dots>
                                </NumberBox>
                                <TextBox>
                                    <h3 className={isDesktop ? h3() : h4()}>{item.title}</h3>
                                    <p className={p()}>{item.description}</p>
                                </TextBox>
                            </StepItem>
                            :
                            <StepItem>
                                <NumberBox>
                                    <h3 className={isDesktop ? h3() : h4()}>{index + 1}</h3>
                                </NumberBox>
                                <TextBox>
                                    <h3 className={isDesktop ? h3() : h4()}>{item.title}</h3>
                                    <p className={p()}>{item.description}</p>
                                </TextBox>
                            </StepItem>
                    )
                }
            </StepsWrapper>
        </Container>
    )
}

export default StepInstruction;

const Container = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '154px 16px  56px',
    position: 'relative',
    gap: '24px',
    color: '$grayscale100',
    svg: {
        top: 0,
        right: 0,
        width: '200px',
        position: 'absolute',
    },
    h1: {
        width: 'fit-content',
        margin: 0,
    },
    '@bp4': {
        h1: {
            width: 'fit-content',
            margin: 0,
        },
        svg: {
            top: 48,
            right: 0,
            width: '300px',
            position: 'absolute',
        },
    },
    '@bp5': {
        padding: '168px 84px',
        gap: '96px',
        svg: {
            top: 0,
            right: 0,
            position: 'absolute',
        },
        h1: {
            width: '100%',
            maxWidth: '1440px',
            margin: 0,
        },
    }
})

const StepsWrapper = styled('div', {
    display: 'flex',
    gap: '16px',
    flexDirection: 'column',
    '@bp5': {
        gap: '24px',
        width: '100%',
        maxWidth: '1440px',
        flexDirection: 'row',
    }
})

const StepItem = styled('div', {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    width: '100%',
    height: 'fit-content',
    '@bp5': {
        flexDirection: 'column',
        width: '33%',
        gap: '48px',
    }
})

const NumberBox = styled('div', {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    gap: '12px',
    h3: {
        flexShrink: 0,
        display: 'grid',
        placeItems: 'center',
        color: '$natematPrimary',
        background: '$primary60',
        borderRadius: '100%',
        width: '40px',
        height: '40px',
        margin: '0px',
    },
    '@bp5': {
        gap: '26px',
        flexDirection: 'row',
        h3: {
            flexShrink: 0,
            width: '64px',
            height: '64px',
        },
    }
})

const Dots = styled('div', {
    height: '100%',
    width: '1px',
    borderLeft: '1px dashed $grayscale50',
    borderTop: 'none',
    "@bp5": {
        width: '100%',
        height: '1px',
        borderTop: '1px dashed $grayscale50',
        borderLeft: 'none',
    }
})

const TextBox = styled('div', {
    display: "flex",
    flexDirection: 'column',
    gap: '4px',
    width: '100%',
    maxWidth: '276px',
    marginTop: '8px',
    '@bp5': {
        marginTop: '0px',
        gap: '16px',
        width: '380px',
    },
    '*': {
        margin: 0,
    }
})